<template>
  <div class="paper">
    <div class="paper-content" v-if="paper.length">
      <div style="padding: 30px;">
        <p class="text-paragraph text-right" v-if="question.questionType === QUESTION_TYPE.CHOOSE_SINGLE">
          【单选题】请选出正确的答案
        </p>
        <p class="text-paragraph text-right" v-if="question.questionType === QUESTION_TYPE.CHOOSE_MULTIPLE">
          【多选题】请选出所有正确的答案
        </p>
        <p class="text-paragraph text-right" v-if="question.questionType === QUESTION_TYPE.JUDGMENT">
          【单选题】请做出正确的判断
        </p>

        <p class="paper-question text-bold text-big text-theme">{{ value + 1 }}、{{ question.title }}</p>
        <div>
          <RadioGroup v-model="answer" v-if="question.questionType === QUESTION_TYPE.CHOOSE_SINGLE">
            <p class="paper-answer" v-for="item in question.answers" :key="item">
              <Radio :label="item" />
            </p>
          </RadioGroup>
          <CheckboxGroup v-model="answer" v-if="question.questionType === QUESTION_TYPE.CHOOSE_MULTIPLE">
            <p class="paper-answer" v-for="item in question.answers" :key="item">
              <Checkbox :label="item" />
            </p>
          </CheckboxGroup>
          <RadioGroup v-model="answer" v-if="question.questionType === QUESTION_TYPE.JUDGMENT">
            <p class="paper-answer" v-for="item in question.answers" :key="item">
              <Radio :label="item">{{ item === 'TRUE' ? '正确' : '错误' }}</Radio>
            </p>
          </RadioGroup>
        </div>
      </div>
    </div>

    <div class="paper-control">
      <Button type="primary" @click="handlePaperControl(-1)" :disabled="value <= 0">上一题</Button>
      <Button type="primary" @click="handlePaperControl(1)" :disabled="!!paper.length && value >= paper.length - 1">下一题</Button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EXAMINATION } from '../../../libs/namespace'
import { QUESTION_TYPE } from '../../../libs/constant'

export default {
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      QUESTION_TYPE,
      prevDisabled: true,
      nextDisabled: true
    }
  },
  computed: {
    ...mapState(EXAMINATION, [ 'paper', 'answers' ]),
    question () {
      return this.paper[this.value]
    },
    answer: {
      get: function () {
        const choosedAnswer = this.answers[this.value]
        if (this.question.questionType === QUESTION_TYPE.CHOOSE_MULTIPLE) {
          return choosedAnswer
        } else {
          return choosedAnswer.length ? choosedAnswer[0] : ''
        }
      },
      set: function (value) {
        this.answers.splice(this.value, 1, Array.isArray(value) ? value : [ value ])
      }
    }
  },
  handlers: {
    handlePaperControl (step) {
      this.$emit('input', this.value + step)
    }
  }
}
</script>

<style lang="less" scoped>
.paper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  &-content {
    flex: auto;
    overflow-y: auto;
  }
  &-question {
    margin: 2em 0;
  }
  &-answer {
    margin-bottom: 1em;
    padding-left: 1em;
  }
  &-control {
    flex: none;
    display: flex;
    justify-content: space-between;
    padding: 30px;
  }
}
</style>
